import { isNull, isUndefined } from '@antv/util';
export function isValid(x) {
    return !isUndefined(x) && !isNull(x) && !Number.isNaN(x);
}
//# sourceMappingURL=is-valid.js.map